import { apiClient } from '~/shared/api/data-ingestion-api'
import { type DocumentPageRange } from './types'

export function getInitialDocumentPageRanges(documents: apiClient.Document[]): DocumentPageRange[] {
  return documents
    .map((document) => ({
      documentId: document.key,
      pageRange: {
        startPage: document.page_range.start_page,
        endPage: document.page_range.end_page,
      },
      // TODO: use `document.confidence_score` when API is ready
      confidenceScore: 1,
    }))
    .sort((a, b) => a.pageRange.startPage - b.pageRange.startPage)
}
